import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {userActions, UserActionTypes} from './user.actions';
import {map, switchMap} from 'rxjs/operators';
import {CompanyUserSandbox} from '../sandboxes/company-user-sandbox.service';

@Injectable()
export class UserEffects {
  private readonly companyUserSandbox = inject(CompanyUserSandbox);
  private readonly actions$ = inject(Actions);

  refreshUserStatistics$ = createEffect(() => this.actions$.pipe(
    ofType(UserActionTypes.ClearUserStatistics),
    switchMap(this.companyUserSandbox.getUserStatistics),
    map((stat) => userActions.setUserStatistics({statistics: stat}))
  ));
}
